<template>
  <!--
    作者：luoyiming
    时间：2020-06-25
    描述：插件中心-限时秒杀-秒杀活动-基础设置
  -->
  <div class="active-basic">
    <div class="common-form">基本信息</div>

    <el-form-item label="名称" prop="name" :rules="[{ required: true, message: '请输入名称', trigger: 'blur' }]">
      <el-input v-model="form.name" placeholder="请输入名称" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="图片" prop="image_id" :rules="rulesImage">
      <div class="d-c-c ad-picture" @click="openUpload">
        <img v-if="form.image_id > 0" :src="form.file_path" width="300" height="124" />
        <span v-else class="el-icon-picture-outline"></span>
      </div>
      <p class="ml10 gray">提示：图片尺寸建议750x360</p>
    </el-form-item>
    <el-form-item label="关联商品" prop="product_name" >
      <el-input type="text" v-model="form.product_name" placeholder="请选择商品" class="max-w460" :disabled="true"></el-input>
      <el-button @click="changeProduct" icon="el-icon-plus">选择商品</el-button>
      <p>注： 选择的的商品可直接点击进入对应详情页。</p><el-button size="mini" @click="deleteArea()">重新选择</el-button>
    </el-form-item>
     
       <el-form-item label="状态">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="排序">
        <el-input type="number" v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
      </el-form-item>

    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
    <!--商品选择-->
    <Product :isproduct="isproduct"  :islist="false" @closeDialog="closeProductFunc"></Product>
  </div>
</template>

<script>
import Upload from '@/components/file/Upload';
import Product from '@/components/product/Product.vue';
export default {
  components: {
    /*选择商品组件*/
    Upload,
    Product
  },
  data() {

    /*验证图片是否上传*/
    const validatorImages = (rule, value, callback) =>{
    	if(value<1){
    		return callback(new Error('请上传活动图'));
    	}else{
         callback();
    	}
    };

    return {
      product_name:'',
      isproduct:false,
       /*是否打开添加弹窗*/
        open_add: false,
      /*是否上传图片*/
      isupload: false,
      /*图片是否上传了*/
      rulesImage: [{ validator: validatorImages, required: true, message: '请上传logo', trigger: 'change' }]
    };
  },
  props: {
    form: Object,
    gradeList:Array,
    app_id:Number,
    is_edit:Boolean
  },
  methods: {
    /*上传*/
    openUpload(e) {
      this.isupload = true;
    },
  deleteArea(){
      this.form.product_id = 0;
      this.form.product_name = '';
      this.changeProduct()
    },
    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.form.file_path = e[0].file_path;
        this.form.image_id = e[0].file_id;
      }
      this.isupload = false;
    },
    /*打开弹出层*/
      addClick() {
        this.open_add = true;
      },
    /*关闭获取用户弹窗*/
      closeDialogFunc(e) {
        if (e.type != 'error') {
          this.user_info = e.params[0];
          this.form.user_id = e.params[0].user_id;
        }
        this.open_add = false;
      },
      /*取消*/
    cancelFunc(){
      this.$router.push({
        path:'/plus/coupon/index',
      });
    },
    /*打开添加*/
    changeProduct(list) {
      this.isproduct = true;
    },
    /*关闭商品选择*/
    closeProductFunc(e) {
      console.log(e)
      this.isproduct = false;
      if (e.type == 'success') {
        this.form.product_id = e.params.product_id;
        this.form.product_name = e.params.product_name;
      }
    },
    
  }
};
</script>

<style lang="scss">
.active-basic .ad-picture {
  width: 300px;
  height: 124px;
  border-radius: 16px;
  font-size: 40px;
  border: 1px dashed #cccccc;
  color: $blue;
  cursor: pointer;
  overflow: hidden;
}
.active-basic .ad-picture:hover {
  border: 1px dashed $blue;
}

.active-basic .ad-picture img {
  object-fit: fill;
}
 .img {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/banner/banner/part/Basic.vue